module.exports = __webpack_public_path__ + "static/media/rundkolben_fertig.05ee1a51.jpg";